module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#close",
      toString: function () {
        return this.url;
      }
    }